import { Component, Output, EventEmitter, Input, OnChanges, OnInit } from '@angular/core';
import { UserJobsService } from '../user-jobs.service';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastService, BzgModalRef, BzgModalService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';
import { EJobType } from 'app/scheduler/jobs/job-type.enum';
import * as _ from 'lodash';
import { SavePendingChangesComponent } from '../../../shared/components/save-pending-changes/save-pending-changes.component';
import { IUserJob } from 'app/scheduler/core/IUserJob';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'user-jobs-description',
    templateUrl: 'user-jobs-description.component.html',
    styleUrls: ['user-jobs-description.component.scss']
})
export class UserJobsDescriptionComponent implements OnChanges, OnInit {
    @Input() userJobs?: Array<IUserJob>
    @Input() currentUserJob: IUserJob;
    @Output() cancel = new EventEmitter();
    @Output() resetEmit = new EventEmitter();
    @Output() userJobUpdate = new EventEmitter();

    public jobType: EJobType = EJobType.User;
    public modalRef: BzgModalRef;
    public job: IUserJob;
    public isValidSettings = true;
    public isValidSteps = true;
    public isValidSchedules = true;
    public isDevelopment: boolean = false;

    // En el componente padre
    public sharedJobStates: { [key: string]: { rescheduleJob: boolean, switchActivated: boolean, originalNextRuntimeDate: Date, nextRuntimeDate: Date } } = {};

    constructor(private _userJobService: UserJobsService,
        private _translateService: TranslateService,
        private _toastService: BzgToastService,
        private _modalService: BzgModalService,
        private _i18nService: I18nService,
        private _showToastService: ShowToastService) { }

    ngOnInit(): void {
        this.isDevelopment = this.checkIfDevelopmentEnvironment();
    }

    ngOnChanges() {
        this.job = _.cloneDeep(this.currentUserJob);
        this.resetValidations();
    }

    public async validatePendingChanges() {
        const isDateDifferent = new Date(this.currentUserJob.nextRuntime).getTime() !== new Date(this.job.nextRuntime).getTime();
        const isEnabledDifferent = this.currentUserJob.enabled !== this.job.enabled;

        if (isDateDifferent || isEnabledDifferent) {
            this.modalRef = this._modalService.open(SavePendingChangesComponent, { closeOnRouterNavigation: true });
            this.modalRef.afterClosed().subscribe(result => {
                switch (result.action) {
                    case 'cancel':
                        this.modalRef.close();
                        break;
                    case 'dontsave':
                        this.modalRef.close();
                        this.cancelAction();
                        break;
                    case 'save':
                        this.saveUserJob(this.job, true)
                        this.modalRef.close();
                        break;
                    case 'close':
                        this.modalRef.close();
                        break;
                }
            });
        } else {
            this.cancelAction();
        }
    }

    public async saveUserJob(userJob: any, closeAfter = false) {
        this._userJobService.update(userJob).subscribe((response) => {
            this.currentUserJob = userJob;
            this.userJobUpdate.emit(this.currentUserJob);
            if (closeAfter) {
                this.cancelAction();
            }
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
            this.reset();
        }, (error) => {
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'), 'error');
        });
    }

    public cancelAction() {
        this.cancel.emit();
    }

    public reset() {
        this.resetEmit.emit();
    }

    public onSettingsValidation(isValid: boolean) {
        this.isValidSettings = isValid;
    }

    public onStepsValidation(isValid: boolean) {
        this.isValidSteps = isValid;
    }

    public onSchedulesValidation(isValid: boolean) {
        this.isValidSchedules = isValid;
    }

    public getOtherTabsValidation(excludeTab: 'settings' | 'steps' | 'schedules'): boolean {
        switch (excludeTab) {
            case 'settings':
                return this.isValidSteps && this.isValidSchedules;
            case 'steps':
                return this.isValidSettings && this.isValidSchedules;
            case 'schedules':
                return this.isValidSettings && this.isValidSteps;
            default:
                return true;
        }
    }

    private checkIfDevelopmentEnvironment(): boolean {
        const DEVELOPMENT_ENV = 'development';
        const environmentType = (sessionStorage.getItem('environmentType') ?? '').trim().toLowerCase();
        return environmentType === DEVELOPMENT_ENV;
    }

    private resetValidations() {
        this.isValidSettings = true;
        this.isValidSteps = true;
        this.isValidSchedules = true;
    }
}
